import React from "react";
import { NavLink } from "react-router-dom";
import styled, { keyframes } from "styled-components";

const fadeInOpacity = keyframes`
  0% {
    opacity: 0;
    transform: translateY(-4px);
  }
  100% {
    opacity: 1;
    transform: translateY(0);
  }
`;

const Text = styled.span`
    font-size: 12px;
    color: ${(props) => props.theme.colors.textPrimary}
    padding-left: 10px;
    text-decoration: none;
    font-weight: 700;
`;

const StyledNavLink = styled(NavLink)`
    position: relative;
    display: flex;
    align-items: center;
    flex-direction: row;
    height: 40px;
    padding: 0 5px 0 25px;
    text-decoration: none;
    opacity: 1;
    animation-name: ${fadeInOpacity};
    animation-iteration-count: 1;
    animation-timing-function: ease-out;
    animation-duration: 0.2s;
    animation-fill-mode: both;

    &:hover, &.selected {
        //background-color: ${(props) => props.theme.colors.primary};
        text-decoration: none;
        ${Text} {
            color: ${(props) => props.theme.colors.primary}
        }
        svg path:not([fill="none"]) {
            fill: white !important;
        }
        svg path:not([stroke="none"])
            stroke: white !important;
        }
    }

    &[data-link-id='now']:hover, &[data-link-id='now'].selected {
        background-color: ${(props) => props.theme.colors.success};    
    }
`;

const StyledNavLinkExternal = styled.a`
    position: relative;
    display: flex;
    align-items: center;
    flex-direction: row;
    height: 40px;
    padding: 0 5px 0 25px;
    text-decoration: none;
    opacity: 1;
    animation-name: ${fadeInOpacity};
    animation-iteration-count: 1;
    animation-timing-function: ease-out;
    animation-duration: 0.2s;
    animation-fill-mode: both;

    &:hover, &.selected {
        //background-color: ${(props) => props.theme.colors.primary};
        text-decoration: none;
        ${Text} {
            color: ${(props) => props.theme.colors.primary}
        }
        svg path:not([fill="none"]) {
            fill: white !important;
        }
        svg path:not([stroke="none"])
            stroke: white !important;
        }
    }
`;

export const Submenu = ({ id, color, name, link }) => {
  if (id === "openportaladmin") {
    return (
      <>
        <StyledNavLinkExternal href={link} target="_blank">
          <Text color={color}>{name}</Text>
        </StyledNavLinkExternal>
      </>
    );
  } else {
    return (
      <StyledNavLink data-link-id={id} to={link} activeClassName="selected">
        <Text color={color}>{name}</Text>
      </StyledNavLink>
    );
  }
};
